import React, { Component } from 'react';
import "./index.less";
import {messageShow } from '../../utils/http';
import PlatformName from '../../components/platformName/index.jsx';

class DialogShowPlatforms extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
          selectPlatform:props.platforms?props.platforms:"TouTiao",
          platforms: [
                { id: 1, title: "抖音", value: "TouTiao", active: true },
                { id: 2, title: "快手", value: "KuaiShou", active: false },
                { id: 3, title: "拼多多", value: "Pinduoduo", active: false },
                { id: 4, title: "淘宝", value: "Taobao", active: false },
                { id: 5, title: "微信视频号", value: "WxVideo", active: false },
                { id: 6, title: "小红书", value: "XiaoHongShu", active: false },
                { id: 7, title: "有赞", value: "YouZan", active: false },
                { id: 8, title: "快团团", value: "KuaiTuanTuan", active: false },
                { id: 9, title: "微盟", value: "WeiMeng", active: false },
                
          ],  //所有平台 
          environmentNumber:0
        };

        this.setData();
    }
    componentWillReceiveProps(props) {  //监听父元素 传过来值的变化 触发的函数
      this.setState({
        selectPlatform: props.platforms
      })
    }


    setData=()=>{
      // if(app.serverLinkUrl.indexOf("zk5") !=-1)
      // {
      //   setTimeout(() => {
      //     this.setState({ platforms: [
      //           { id: 1, title: "抖音", value: "TouTiao", active: true },
      //           { id: 2, title: "快手", value: "KuaiShou", active: false },
      //           { id: 3, title: "拼多多", value: "Pinduoduo", active: false },
      //           { id: 4, title: "淘宝", value: "Taobao", active: false },
      //           { id: 5, title: "微信视频号", value: "WxVideo", active: false },
      //           { id: 6, title: "小红书", value: "XiaoHongShu", active: false },
      //       ],
      //       environmentNumber:5
      //      });
      //   }, 0);
      // }
    }


    changeShop=(platformName)=>{
        messageShow(platformName+'开发对接中...','warning',2000);
    }
    changeShop2=(event)=>{
      let platforms = this.state.platforms;
      let selectPlatform = this.state.selectPlatform;
      var id=event.currentTarget.getAttribute('id');
      for (var i = 0; i < platforms.length; i++) {
          if (platforms[i].id == id) {
              platforms[i].active = true;
              selectPlatform=platforms[i].value;
          } else {
              platforms[i].active = false;
          }
      }
      this.setState({
          platforms: platforms,
          selectPlatform:selectPlatform
      })
     
      this.props.changeShops(platforms,selectPlatform);
    }

    render() {
      return (
        // <div className="addShopDailog" >
        //             <table class="table02">
        //                 <tbody>
        //                 <tr>
        //                         {this.state.platforms.map((item, index) =>
        //                             <td className={item.active ? "platform active" : "platform"} id={item.id} index={index} onClick={(event) => this.changeShop2(event)}>
        //                                 <div className={item.value}></div>
        //                                 <span>{item.title}</span>
        //                             </td>
        //                         )}
        //                     </tr>
        //                 </tbody>
        //             </table>
        // </div>

          <div class="newAddShop">
              <ul class="newAddShop-main">
                  {this.state.platforms.map((item,index)=>  
                    <li className={item.active ? "active" : ""} id={item.id} index={index} onClick={(event) => this.changeShop2(event)}>
                        <PlatformName platformType={item.value} iconSize={"middleIcon"} isHidePatformName={true} />
                        <span class="pintaiName">{item.title}平台</span>
                    </li>
                    
                  )}
                  
                  {/* 支持了淘宝，所以隐藏下，先不删除 */}
                  {/* {
                    this.state.environmentNumber !=5?
                    <li onClick={() => this.changeShop("淘宝平台")}>
					        	    <span class="newPlatformIcon middleIcon" style={{"backgroundPosition":"-150px -402px"}}></span>
					        	    <span class="pintaiName">淘宝平台</span>
					        	    <span class="pintaiWarn">敬请期待</span>					
					          </li>:null
                  } */}
                 
					        {/* <li onClick={() => this.changeShop("微信小商店")}>
					        	<span class="newPlatformIcon middleIcon" style={{"backgroundPosition":"-200px -402px"}}></span>
					        	<span class="pintaiName">微信小商店</span>
					        	<span class="pintaiWarn">敬请期待</span>					
					        </li> */}
					        <li style={{"border": "1px solid #fff"}}></li>
					        <li style={{"border": "1px solid #fff"}}></li>
					        <li style={{"border": "1px solid #fff"}}></li>
              </ul>
          </div>
      );
    }



  };

  export default DialogShowPlatforms;



// WEBPACK FOOTER //
// ./src/components/dialogShowPlatforms/index.jsx